import { FunctionComponent, useEffect, useState } from 'react';
import { faChartSimple, faTags, faHandshake, faBarcodeRead, faBoxes } from '@fortawesome/pro-light-svg-icons';
import { useHistory, useLocation } from 'react-router-dom';
import ProductsComponent, { ProductsViewId } from 'components/Products';
import PageSidebar, { PageSidebarItem } from 'components/PageSidebar';
import PrivatePage from './PrivatePage';
import { ProductsPath } from 'routes/Paths';

const pageSidebarItems: Array<PageSidebarItem> = [
    { icon: faChartSimple, title: 'Dashboard', key: 'dashboard' },
    { icon: faTags, title: 'Products', key: 'products' },
    { icon: faBoxes, title: 'Stock', key: 'stock' },
    { icon: faHandshake, title: 'Suppliers', key: 'vendors' },
    { icon: faBarcodeRead, title: 'Categories', key: 'categories' }
];

const isProductsViewId = (value: string): value is ProductsViewId => {
    return pageSidebarItems.some(item => item.key === value);
};

const getViewIdFromHash = (hash: string): ProductsViewId => {
    const viewId = hash.replace('#', '');
    return isProductsViewId(viewId) ? viewId : 'dashboard';
};

export const Products: FunctionComponent = () => {
    const history = useHistory();
    const location = useLocation();
    const [selectedViewId, setSelectedViewId] = useState<ProductsViewId>(getViewIdFromHash(location.hash));
    const [sidebarSelectionKey, setSidebarSelectionKey] = useState(0);

    useEffect(() => {
        const viewId = getViewIdFromHash(location.hash);
        setSelectedViewId(viewId);
        setSidebarSelectionKey(prev => prev + 1);
    }, [location.hash]);

    const handleSelectView = (key: string) => {
        if (!isProductsViewId(key)) {
            return;
        }

        if (getViewIdFromHash(location.hash) === key) {
            setSidebarSelectionKey(prev => prev + 1);
            return;
        }

        history.replace(`${ProductsPath}#${key}`);
    };

    const sidebar = (
        <PageSidebar
            title="Inventory"
            items={pageSidebarItems}
            selectedKey={selectedViewId}
            onSelect={handleSelectView}
        />
    );

    return (
        <PrivatePage
            title="Products - Cuddles"
            pageName="/products"
            pageSidebar={sidebar}
        >
            <ProductsComponent
                selectedViewId={selectedViewId}
                sidebarSelectionKey={sidebarSelectionKey}
            />
        </PrivatePage>
    );
};

export default Products;
